/**
 * The Field Service Path's strings on the Work Order page (piece 29; decisions
 * 1901, 1904, 1906, 1908): the Visits tile, the Labour tile, Record time and
 * Raise a Correction. Spread into the one lookup in `strings.ts`, so `t()`
 * stays the only way a screen reads text. 🔨 This file imports nothing.
 */
export const FIELD_SERVICE_STRINGS = {
  // 🔒 Piece 29 (T3851): the lines still Pending stop a visit's completion and the job's own Complete, each in its own words.
  'workOrder.pending.visitOne': 'The visit has 1 line still Pending: {lines}. Mark it Complete, Not complete or Not needed before the visit completes.',
  'workOrder.pending.visitMany': 'The visit has {count} lines still Pending: {lines}. Mark each Complete, Not complete or Not needed before the visit completes.',
  'workOrder.pending.jobOne': 'The job has 1 line still Pending; mark it Complete, Not complete or Not needed before the job completes.',
  'workOrder.pending.jobMany': 'The job has {count} lines still Pending; mark each Complete, Not complete or Not needed before the job completes.',
  // The Visits tile (decision 1908).
  'workOrder.visits.none': 'No visit is booked on this job yet. Book the Visit books the first, with its crew.',
  'workOrder.visits.visit': 'Visit',
  'workOrder.visits.window': 'Date and window',
  'workOrder.visits.lead': 'Lead',
  'workOrder.visits.crew': 'Crew',
  'workOrder.visits.state': 'State',
  'workOrder.visits.outcome': 'Outcome',
  'workOrder.visits.leadMark': '(lead)',
  'workOrder.visits.noLead': 'No lead named',
  'workOrder.visits.nobody': 'Nobody named',
  'workOrder.visits.couldNotComplete': 'Could not complete',
  'workOrder.visits.completed': 'Completed',
  // 🔒 Piece 29 (T3859; the owner's S9a): a crew member who has not opened the job on My Jobs, and what the chip says on hover.
  'workOrder.visits.notOpened': 'Not Yet Opened',
  'workOrder.visits.notOpenedSince': '{name} has not opened this job on My Jobs. They last opened My Jobs {when}.',
  'workOrder.visits.notOpenedEver': '{name} has not opened My Jobs yet.',
  'workOrder.visits.tapsHint': 'A visit booked with a crew is sent to them at once. It moves to In Progress on the technician’s first Clock In or Arrived on My Jobs, and the job with it; the job’s Complete waits until each visit is completed or canceled.',
  // 🔒 Decision 4340: a visit still to come with nobody on it waits for its crew, and Edit Visit names them, which sends it.
  'workOrder.visits.nobodyBooked': 'Nobody is booked on {visit} yet. Edit Visit names the crew, which sends the visit to them.',
  'workOrder.visits.bookAnother': 'Book Another Visit',
  // 🔒 Decision 5570 (the owner's W5a): every booking form draws the same fields, Who Can Go inline, and the tile books with no window.
  'workOrder.booking.bookFirst': 'Book the Visit',
  'workOrder.booking.inlineHint': 'Pick the window, then add the crew from Who Can Go and tick the lines each one works. Save books the visit and sends it to the crew, who are told after the quiet window.',
  'workOrder.booking.whoCanGoHint': 'Free in this window first, then qualified for the job, then nearest the site, as the Dispatch Board ranks them.',
  'workOrder.booking.whoCanGoWaits': 'Pick a start to see who can go.',
  'workOrder.booking.free': 'Free',
  'workOrder.booking.add': 'Add',
  'workOrder.booking.added': 'Added',
  // 🔒 Decision 5571: the lines a visit covers, and each worker's.
  'workOrder.booking.lines': 'Lines this visit covers',
  'workOrder.booking.noLines': 'No line is ticked, so the Service Report lists no line for this visit.',
  'workOrder.booking.workerLines': '{name} works',
  'workOrder.booking.workerNoLine': '{name} is sent for no line on this visit.',
  // 🔒 Decision 5572 (T2785): the booking is not refused; the sentence stands beside the worker before Save.
  'workOrder.booking.noLogin': '{name} has no login, so the job will not reach My Jobs.',
  'workOrder.booking.noEmployment': '{name} holds no open employment, so the job will not reach My Jobs.',
  'workOrder.booking.firstVisit': 'First Visit',
  'workOrder.booking.firstVisitHint': 'Fill Starts to book the first visit with the job, and Save sends it to the crew. Leave Starts empty to save the job unbooked, and it waits in Unscheduled.',
  'workOrder.booking.needsStart': 'A visit is booked with the day and time it starts. Name the start, or clear the end and the crew to save the job unbooked.',
  'workOrder.booking.fixedNeedsReason': 'A fixed visit says why it cannot move. Type the reason, or choose Can move.',
  'workOrder.visits.bookTitle': 'Book Another Visit',
  'workOrder.visits.bookHint': 'A second visit on the same job. The first visit and the job’s own booking stay where they are.',
  'workOrder.visits.cancel': 'Cancel Visit',
  'workOrder.visits.cancelTitle': 'Cancel a Visit',
  'workOrder.visits.cancelReason': 'Why the visit is canceled',
  'workOrder.visits.cancelled': 'Canceled:',
  // The tile's rows sit in the List Viewer (piece 4): its name, its one view, and Cancel Visit on the action bar.
  'workOrder.visits.recordType': 'Visits',
  'workOrder.visits.view': 'Every visit',
  'workOrder.visits.tickToCancel': 'Tick a visit still to come to edit or cancel it.',
  'workOrder.visits.tickToDeleteAnyway': 'Tick a visit still to come to edit or cancel it, or any visit to delete it anyway.',
  'workOrder.visits.chooseOne': 'Tick one visit still to come to edit or cancel it.',
  // Edit Visit (decision 2813): the one window the tile, the visit's page and the job's Reschedule open on a visit.
  'workOrder.visits.edit': 'Edit Visit',
  'workOrder.visits.editTitle': 'Edit Visit',
  'workOrder.visits.editHint': 'Change the window, the crew or the lead. The workers are told once the change settles, and the customer hears of a new window.',
  'workOrder.visits.startedWindow': 'This visit has started, so its window stays where it happened. Only its crew changes.',
  'workOrder.visits.moveReason': 'Why the visit moves',
  'workOrder.visits.saved': 'The visit is saved.',
  // A visit Can move or is Fixed with a typed reason (decision 3100; T2186).
  'workOrder.visits.movable': 'Can this visit move?',
  'workOrder.visits.canMove': 'Can Move',
  'workOrder.visits.fixed': 'Fixed',
  'workOrder.visits.fixedReason': 'Why it is fixed',
  'workOrder.visits.fixedHint': 'A Fixed visit draws a red edge on the Schedule and the Dispatch Board, and a drag asks before it moves.',
  'workOrder.visits.fixedOnPage': 'Fixed: {reason}',
  // The lead a booking names (decision 1901).
  'workOrder.schedule.lead': 'Lead worker',
  'workOrder.schedule.leadHint': 'The lead alone completes the visit and asks for the signature.',
  // The Labour tile (decision 1908).
  'workOrder.labour.none': 'No hours are recorded or typed on this job yet.',
  'workOrder.labour.who': 'Who',
  'workOrder.labour.line': 'Line',
  'workOrder.labour.in': 'In',
  'workOrder.labour.out': 'Out',
  'workOrder.labour.hours': 'Hours',
  'workOrder.labour.how': 'How',
  'workOrder.labour.billingRate': 'Billing rate',
  'workOrder.labour.costRate': 'Cost rate',
  'workOrder.labour.cost': 'Cost',
  'workOrder.labour.invoice': 'Invoice',
  'workOrder.labour.withheld': 'Withheld',
  'workOrder.labour.unbilled': 'Unbilled',
  'workOrder.labour.draftInvoice': 'Draft invoice',
  'workOrder.labour.travel': 'Travel',
  'workOrder.labour.jobOnly': 'The job, no line',
  'workOrder.labour.typedRow': 'Typed on the line',
  'workOrder.labour.typedBills': 'bills: this worker has no entries on the line',
  'workOrder.labour.typedNotBilled': 'not billed while entries exist',
  'workOrder.labour.correction': 'Correction:',
  'workOrder.labour.pending': 'Awaiting approval',
  'workOrder.labour.budget': 'Budget',
  'workOrder.labour.actual': 'Actual',
  'workOrder.labour.typed': 'typed',
  'workOrder.labour.entries': 'entries',
  'workOrder.labour.billed': 'Billed',
  'workOrder.labour.remaining': 'Remaining',
  'workOrder.labour.noBudget': 'no budget',
  'workOrder.labour.jobTotal': 'The whole job',
  'workOrder.labour.unlined': 'Travel and time on the job with no line',
  // The tile's rows sit in the List Viewer (piece 4): its name, its one view, and Raise a Correction on the action bar.
  'workOrder.labour.recordType': 'Time entries',
  'workOrder.labour.view': 'Every entry',
  'workOrder.labour.tickToCorrect': 'Tick an entry to raise a correction on it.',
  'workOrder.labour.chooseOne': 'Tick one entry to correct; a typed row or a correction takes none.',
  // Record time (decision 1904).
  'workOrder.time.record': 'Record Time',
  'workOrder.time.recordTitle': 'Record Time',
  'workOrder.time.worker': 'Worker',
  'workOrder.time.day': 'Day worked',
  'workOrder.time.hours': 'Hours',
  'workOrder.time.from': 'From',
  'workOrder.time.to': 'To',
  'workOrder.time.note': 'Note',
  'workOrder.time.hint': 'Hours, or a from and a to. The entry is marked Typed, waits for approval, and counts for this worker on this line in place of their typed hours.',
  // Raise a Correction (decision 1906).
  'workOrder.time.correct': 'Raise a Correction',
  'workOrder.time.correctTitle': 'Raise a Correction',
  'workOrder.time.correctHours': 'Hours to add, or a minus figure to take off',
  'workOrder.time.correctReason': 'Reason',
  'workOrder.time.correctHint': 'The entry stays as it is. The correction is a new entry naming it, and bills on the next invoice from the job.',
  // My Jobs, the technician's board under Work (decision 1909).
  'myJobs.title': 'My Jobs',
  'myJobs.hint': 'Your open jobs, one card each. A card moves on your own taps and your clock, never by dragging, and shows hours, never a rate.',
  'myJobs.column.scheduledToday': 'Scheduled Today',
  'myJobs.column.inProgress': 'In Progress',
  'myJobs.column.waiting': 'Waiting',
  'myJobs.column.doneToday': 'Done Today',
  'myJobs.column.comingUp': 'Coming Up',
  'myJobs.columns': 'Columns',
  'myJobs.columnEmpty': 'Nothing here.',
  'myJobs.new': 'New',
  'myJobs.newLabel': 'New on your board since you last opened My Jobs',
  'myJobs.newCount': '{count} new jobs in this column',
  'myJobs.newCountOne': '1 new job in this column',
  'myJobs.waitingEmpty': 'A job on hold waits here with its reason.',
  'myJobs.show': 'Show',
  'myJobs.hide': 'Hide',
  'myJobs.person': 'Person',
  'myJobs.readingOther': 'You are reading another person’s board. Nobody clocks for anybody else, so it offers no control.',
  'myJobs.noEmployment': 'You hold no employment, so you have no board of your own.',
  'myJobs.noJobs': 'No open job names you on a line or a visit.',
  'myJobs.noVisit': 'No visit booked',
  'myJobs.travelToday': 'Travel today',
  'myJobs.today': 'today',
  'myJobs.notOnLine': 'You are on this job’s visit and on none of its lines; the office puts you on a line first.',
  'myJobs.clockIn': 'Clock In',
  'myJobs.clockOut': 'Clock Out',
  'myJobs.recordTime': 'Record Time',
  'myJobs.runningSince': 'Clock running since',
  'myJobs.runningElsewhere': 'Your clock runs on another job; Clock In here ends it at the same minute.',
  'myJobs.ended': 'Your running clock ended at the same minute:',
  'myJobs.endedHours': 'recorded',
  'myJobs.started': 'Clocked in at',
  'myJobs.visitStarted': 'The visit started with this Clock In.',
  'myJobs.jobStarted': 'The job moved to In Progress.',
  'myJobs.checkedIn': 'You are checked in at the site.',
  'myJobs.stopped': 'Clocked out:',
  'myJobs.checkedOut': 'You are checked out of the site.',
  'myJobs.gatedHint': 'This site runs gate sign-in, and the gate is the clock here.',
  'myJobs.recordHint': 'Typed time is written for today and waits for approval. A note says what the hours were.',
  'myJobs.hours': 'Hours',
  'myJobs.note': 'Note',
  'myJobs.save': 'Save',
  'myJobs.onMyWay': 'On My Way',
  'myJobs.arrived': 'Arrived',
  'myJobs.leaving': 'Leaving',
  'myJobs.minutes': 'About how many minutes?',
  'myJobs.minutesHint': 'Filled from the drive time from your office to the site where it is known. The minutes are kept with your tap; the customer message that names them is not sent yet.',
  'myJobs.toldOnMyWay': 'On My Way is recorded.',
  'myJobs.toldArrived': 'Arrived is recorded.',
  'myJobs.toldLeaving': 'Leaving is recorded.',
  'myJobs.toldAgain': 'The visit already carried this stamp, so nothing moved.',
  'myJobs.clockStopped': 'Your clock on this job stopped:',
  'myJobs.travelTitle': 'Record Travel',
  'myJobs.travelHint': 'You tapped On My Way before this Clock In. Confirm or change the minutes to record them as travel, or decline and nothing is written.',
  'myJobs.travelMinutes': 'Minutes of travel',
  'myJobs.travelDecline': 'Decline',
  'myJobs.travelRecorded': 'Travel recorded:',
  'myJobs.submitDay': 'Submit Day',
  'myJobs.submitHint': 'Submit Day sends every entry of yours still awaiting approval, dated today or earlier, to the approver.',
  'myJobs.submitCount': 'Entries to submit:',
  'myJobs.submitNothing': 'No entry of yours waits to be submitted.',
  'myJobs.submitClock': 'Your clock is still running. Clock Out before you submit the day.',
  'myJobs.splitTitle': 'Split the gate time across the lines',
  'myJobs.splitHint': 'The gate recorded your time on the job as a whole. Give each line its share; the shares add up to the gate’s hours.',
  'myJobs.splitOf': 'Gate time',
  'myJobs.splitLeft': 'Still to give:',
  'myJobs.submitted': 'Your day is submitted for approval:',
  'myJobs.submittedEntries': 'entries',
  'myJobs.returnedTitle': 'Returned for correction',
  'myJobs.returnedHint': 'An approver returned these entries. Record the time again on the job with a note, then submit the day again.',
  'myJobs.noReason': 'No reason was given.',
  'timeApproval.title': 'Time Awaiting Approval',
  'timeApproval.subtitle': 'Submitted days of time, approved or rejected whole',
  'timeApproval.hint': 'Each worker’s submitted day, approved or rejected whole. A rejection says why, and the worker corrects it with a new entry.',
  'timeApproval.empty': 'No submitted day waits for approval.',
  'timeApproval.approve': 'Approve Day',
  'timeApproval.reject': 'Reject Day',
  'timeApproval.rejectTitle': 'Reject Day',
  'timeApproval.reason': 'Reason',
  'timeApproval.reasonHint': 'The worker reads this on My Jobs.',
  'timeApproval.own': 'Your own day; another approver decides it.',
  // Decision 12931 (T3856): a gate punch beyond the radius from the site's pin, said to the approver alone.
  'timeApproval.farPunch': 'Signed in {distance} from the site’s pin',
  'timeApproval.submitted': 'Submitted',
  'timeApproval.noLine': 'No line',
  'timeApproval.travel': 'Travel',
  // The service request route on a Service deal (piece 18; decision 1912).
  'deal.classification.serviceRequest': 'Service Request',
  'deal.request.authorityNote': 'Asked for the work when the request came in.',
  'deal.request.formHint': 'A request opens Won. It asks who asked for the work and the problem in their words, and builds no bill of materials.',
  'deal.request.pickAccount': 'Choose the account first; its sites and its people follow.',
  'deal.request.need': 'Need',
  'deal.request.needHint': 'The problem in the caller’s words. It becomes the job’s first line.',
  'deal.request.askedBy': 'Who asked',
  'deal.request.askedByEntity': 'contact',
  'deal.request.site': 'Site',
  'deal.request.asset': 'Asset',
  'deal.request.noAsset': 'No asset named',
  'deal.request.source': 'How it came in',
  'deal.request.receivedAt': 'Came in at',
  'deal.request.receivedNow': 'Left empty, now.',
  'deal.request.windowStart': 'Preferred from',
  'deal.request.windowEnd': 'Preferred until',
  'deal.request.ceiling': 'Ceiling',
  'deal.request.ceilingHint': 'The most the customer agreed to without being asked again. Leave it empty where none was agreed.',
  'deal.request.timeInvalid': 'A time on the request is not a date and time this form can read.',
  'deal.request.band': 'Service Request',
  'deal.request.step.request': 'Request',
  'deal.request.step.workOrder': 'Work Order',
  'deal.request.step.invoice': 'Invoice from the Job',
  'deal.request.stepDone': 'Done',
  'deal.request.stepNow': 'Next',
  'deal.request.cameIn': 'Came in',
  'deal.request.takenBy': 'taken by',
  'deal.request.window': 'Preferred window',
  'deal.request.noWindow': 'No preferred window',
  'deal.request.minimum': 'Billing minimum',
  'deal.request.minimumTier': 'on the {tier} tier',
  'deal.request.noTier': 'No priority tier is in force, so no minimum applies.',
  'deal.request.ceilingNone': 'No ceiling agreed',
  // Decision 12600: the tile's Edit.
  'deal.request.edit': 'Edit',
  'deal.request.edit.title': 'Edit Service Request',
  'deal.request.edit.tier': 'Priority tier',
  'deal.request.edit.tierDerived': 'Follow the preferred window',
  'deal.request.edit.tierHint': 'Left to follow the window, the tier is the notice from when the request came in to the start of the window. A tier picked here stays until it is cleared.',
  'deal.request.edit.minimumFollows': 'The billing minimum and every open job follow the tier saved here.',
  'deal.request.edit.invoiced': 'A job from this request is invoiced, so the tier, the window and the ceiling are fixed.',
  'deal.request.edit.noTier': 'The tier is not one in force.',
  'deal.request.edit.stale': 'This request was changed by somebody else since it was opened, and has been read again; close Edit and open it again to see the new values.',
  'deal.request.raise': 'Raise Work Order',
  'deal.request.working': 'The last press is still being written.',
  // Decision 1913: where the job stands, one derived line under the request's banner.
  'deal.request.status.heading': 'Where the job stands',
  'deal.request.status.cancelled': 'Canceled',
  'deal.request.status.closed': 'Closed',
  'deal.request.status.completed': 'Completed',
  'deal.request.status.couldNotComplete': 'Could not complete',
  'deal.request.status.workInProgress': 'Work in progress',
  'deal.request.status.quoteDeclined': 'Quote declined',
  'deal.request.status.quoteSent': 'Quote sent',
  'deal.request.status.new': 'New',
  'deal.request.status.nextVisit': 'next visit {when}',
  'deal.request.status.with': 'with {name}',
  // Decisions 1914 and 1992: who owns a request, and Name the Owner where the account named no rep.
  'deal.request.owner': 'Owner',
  'deal.request.ownerEntity': 'person employed here',
  'deal.request.ownerFromSite': 'The site’s assigned sales rep owns this request; pick somebody else to change it.',
  'deal.request.ownerFromCompany': 'The account’s assigned sales rep owns this request; pick somebody else to change it.',
  'deal.request.ownerNone': 'The account names no sales rep, so you are written as owner and the invoice from the job waits until somebody names one.',
  'deal.request.ownerWaitingShort': 'waiting to be named',
  'deal.request.ownerWaitingTitle': 'Name the Owner',
  'deal.request.ownerWaiting': '{name} took the call and is written as owner for now. The invoice from the job issues once somebody names the owner here.',
  'deal.request.ownerSomebody': 'Whoever took the call',
  'deal.request.ownerPick': 'Pick the owner first.',
  'deal.request.nameOwner': 'Name the Owner',
  'deal.request.ownerWaitingInvoice': 'This request waits for its owner; name the owner on the Deal before the invoice from its job issues.',
  'history.audit.dealOwnerNamed': 'The owner was named, from {from} to {to}',
  'history.audit.dealRequestTierChanged': 'The request’s priority tier was changed, from {from} to {to}',
  'history.audit.dealRequestWindowChanged': 'The request’s preferred window was changed, from {from} to {to}',
  'history.audit.dealRequestCeilingChanged': 'The request’s ceiling was changed, from {from} to {to}',
  'fieldReports.unowned': 'Emergencies waiting for an owner',
  'fieldReports.unownedHint': 'Emergencies confirmed before the request route, still owned by whoever confirmed them. Open each and name its owner by hand.',
  // Decision 2294: the Service form's Emergency switch, which books the job and dispatches it in the same Save.
  'deal.request.emergency': 'Emergency',
  'deal.request.emergencyHint': 'On, Save books the Deal as an emergency and raises its Work Order from now, dispatched at once. Its approval, where a rule asks for one, is reviewed after.',
  'deal.request.emergencySource': 'An emergency always came in somehow, so say how.',
  'deal.request.technician': 'Technician',
  'deal.request.technicianLater': 'Set on the board',
  'deal.request.textCustomer': 'Text the customer to confirm',
  'deal.request.textTo': 'Who to text',
  'deal.request.textToEntity': 'contact',
  'deal.request.textToAsked': 'Left empty, the text goes to who asked.',
  'deal.request.textNobody': 'Nobody is picked to receive the text, so none goes.',
  'deal.request.textHeading': 'The text, word for word',
  'deal.request.quoteFirst': 'Send a Quote First',
  'deal.request.raiseHint': 'Raise Work Order opens the visit’s window on the request’s preferred window, then writes the job at the request’s site with one labor line from its need. Send a Quote First opens a Service quote carrying the minimum and the ceiling.',
  'deal.request.raiseNeed': 'Need:',
  'deal.request.raiseNoNeed': 'none written yet',
  'deal.request.raiseWindowHint': 'Starts and Ends come from the request’s preferred window. Save writes the job and books this visit with the crew you name. Clear both dates to write the job with no visit.',
  'deal.request.quoteCeilingNote': 'Not to exceed {ceiling} without your approval.',
  'deal.request.quoteMinimumLine': 'Billing minimum',
  'help.dealValue.thisRequestMinimum': 'This request\u2019s value is its billing minimum: the minimum hours its priority tier bills, at that labor\u2019s price, until an invoice from its job issues.',
  'help.dealValue.thisInvoiced': 'This request\u2019s value is the total of the invoices issued from its job.',
  // Decision 2080 (T1264): the customer message rules, on the Field Service tile and under a Deal's Work Orders.
  'jobMessages.title': 'Customer Messages',
  'jobMessages.customerHint': 'Which messages this customer’s jobs send, and to whom. A message with no rule sends nothing.',
  'jobMessages.dealHint': 'This Deal’s jobs follow the customer’s messages unless a message is set here for this Deal alone.',
  'jobMessages.on': 'On',
  'jobMessages.off': 'Off',
  'jobMessages.notSet': 'Not set: sends nothing',
  'jobMessages.to': 'to {names}',
  'jobMessages.followsCustomer': 'Follows the customer',
  'jobMessages.forThisDeal': 'This Deal',
  'jobMessages.edit': 'Set',
  'jobMessages.useCustomers': 'Use the Customer’s',
  'jobMessages.editTitle': '{kind} Message',
  'jobMessages.sendIt': 'Send this message',
  'jobMessages.recipients': 'Send To',
  'jobMessages.recipientsHint': 'A contact employed at the customer. The email goes to their work address, and a text to their mobile where one is on file.',
  'jobMessages.noContacts': 'This customer has no contacts yet. Add one on the Contacts tile first.',
  'jobMessages.noWay': 'no email or mobile',
  'jobMessages.save': 'Save',
  'jobMessages.saved': 'Saved.',
  'jobMessages.setBy': 'Set by {name}',
  // The Schedule view (piece 29; decisions 1911, 2081; T1049).
  'schedule.title': 'Schedule',
  'schedule.hint': 'Each field technician against the hours of the day, their month beside, a mark on each day they have a visit. Tap a day in the month to move there. Drag a job from Unscheduled onto a technician at the hour it starts, or pick it and press Book Here.',
  'schedule.previous': 'Previous Day',
  'schedule.next': 'Next Day',
  'schedule.today': 'Today',
  'schedule.technician': 'Technician',
  'schedule.week': 'Week',
  'schedule.unscheduled': 'Unscheduled',
  'schedule.unscheduledHint': 'Jobs with no visit yet, or a visit with nobody on it, highest priority first. Each says which.',
  'schedule.noUnscheduled': 'Every job waiting to go out has a visit with a crew on it.',
  'schedule.noTechnicians': 'Nobody is a field technician yet: a technician is employed here with a skill level on their position.',
  'schedule.pick': 'Pick',
  'schedule.picked': 'Picked',
  'schedule.booking': 'Booking {job}: choose the hour it starts, then press Book Here on a technician.',
  'schedule.startsAt': 'Starts at',
  'schedule.bookHere': 'Book Here',
  'schedule.cancelPick': 'Cancel',
  'schedule.booked': '{job} is booked on {name} and sent to them.',
  'schedule.lead': 'lead',
  'schedule.noLevel': 'No level',
  'schedule.needs': 'Needs {level}',
  // 🔒 Decision 6021: each technician's month in place of the week's counts.
  'schedule.monthOf': '{name}’s month',
  'schedule.dayBooked': '{day}: a visit booked',
  'schedule.dayFree': '{day}: nothing booked',
  // The month heading, named through t() and not the browser's locale (T2851).
  'schedule.monthName.january': 'January',
  'schedule.monthName.february': 'February',
  'schedule.monthName.march': 'March',
  'schedule.monthName.april': 'April',
  'schedule.monthName.may': 'May',
  'schedule.monthName.june': 'June',
  'schedule.monthName.july': 'July',
  'schedule.monthName.august': 'August',
  'schedule.monthName.september': 'September',
  'schedule.monthName.october': 'October',
  'schedule.monthName.november': 'November',
  'schedule.monthName.december': 'December',
  // The Schedule view's filters and chips (piece 29; decisions 1911, 2081; T1248).
  'schedule.homeShop': 'Home shop',
  'schedule.allShops': 'Every home shop',
  'schedule.level': 'Level',
  'schedule.allLevels': 'Every level',
  'schedule.andAbove': '{level} and above',
  'schedule.noShop': 'No home shop',
  'schedule.filteredOut': 'No technician matches these filters.',
  'schedule.bookedShort': '{job} is booked on {name}, who is short of what it asks: {warnings}.',
  // A dragged block (piece 29; decision 2250; T1570).
  'schedule.moveHint': 'Drag a Scheduled or Dispatched block to another technician or hour to move it, or its right edge to change how long it runs. On a touch screen, press Move on the block, then Move Here on a technician. Its workers are told once the visit has gone quiet.',
  'schedule.resize': 'Drag to change how long {job} {visit} runs',
  'schedule.moved': '{job} {visit} is moved to {name}, {window}. Its workers are told once the visit has gone quiet.',
  'schedule.movedShort': '{job} {visit} is moved to {name}, {window}, who is short of what it asks: {warnings}.',
  'schedule.moveRefused': '{job} {visit} is back where it was: {reason}',
  // A Fixed visit's word, and the question a drag of one asks (decision 3100).
  'schedule.fixed': 'Fixed',
  'schedule.fixedTitle': 'Fixed: {reason}',
  'schedule.fixedAskTitle': 'Move a Fixed Visit?',
  'schedule.fixedAsk': '{job} {visit} is Fixed: {reason}. Moving it changes a time other people are holding to.',
  'schedule.fixedAskConfirm': 'Move It Anyway',
  'schedule.endsBeforeStart': 'a visit ends after it starts, so drop its edge on a later hour.',
  'schedule.crossesMidnight': 'a visit stays inside one day, so drop it earlier or shorten it.',
  // A block moved without a drag, for a touch screen (piece 29; decision 2361; T1572).
  'schedule.move': 'Move',
  'schedule.movePicked': 'Moving',
  'schedule.movingPick': 'Moving {job} {visit}: choose the hour it starts, then press Move Here on a technician. Escape or Moving lets it go.',
  'schedule.moveHere': 'Move Here',
  // Decision 2610 (T1169): the Job Cost tile beside the Labor Lines, for HR and Admin.
  'jobCost.labour': 'Labor at cost',
  'jobCost.travel': 'Travel at cost',
  'jobCost.parts': 'Parts at cost',
  'jobCost.total': 'Total cost',
  'jobCost.billed': 'Billed',
  'jobCost.margin': 'Margin',
  'jobCost.hours': '{hours} h',
  'jobCost.uncosted': '{hours} h carry no pay rate on file and count nothing',
  'jobCost.invoices': '{count} issued from this job, net of tax',
  'jobCost.nothingBilled': 'nothing issued from this job yet',
  'jobCost.draft': '{amount} more on a Draft',
  'jobCost.share': '{percent}% of billed',
  'jobCost.noShare': 'no share while nothing is billed',
  'jobCost.loss': 'Loss',
  // Decision 2612 (T1178): a blanket Service quote's Not to Exceed and allowance lines, and the invoice held past the ceiling.
  'jobCeiling.hold': 'This invoice is held: with it the deal has billed {total}, {over} past its Not to Exceed of {ceiling}. Once the customer agrees a higher figure, record it as the Not to Exceed on a Service quote on the deal, or take {over} off this invoice.',
  'quote.notToExceed': 'Not to Exceed',
  'quote.notToExceedHint': 'The most the customer agreed to. An invoice from the job past it is held.',
  'item.allowance': 'Allowance',
  'item.allowanceHint': 'An allowance bills at actuals from the job.',
} as const;
